import styled from '@emotion/styled';
import {Chip} from '@bosch/react-frok';

export const FilterSelectionWrapper = styled.div`
    min-height: 3rem;
    margin: 1rem 0 1rem;
`;

export const TotalCountContainer = styled.div`
    padding-left: 1rem;
    padding-right: 1rem;
`;

export const ResetChipsButtonContainer = styled.div`
    display: inline;
    text-align: center;
    vertical-align: middle;
`;

export const FilterSortContainer = styled.div`
    text-align: center;
    vertical-align: middle;
`;

export const FiltersContainer = styled.div<{ expanded: boolean }>`
    max-height: ${(props) => (props.expanded ? '100vh' : '0px')};
    opacity: ${(props) => (props.expanded ? 1 : 0)};
    overflow: ${(props) => (props.expanded ? 'visible' : 'hidden')};
    transition: all 0.5s ease-in-out;
`;

export const StyledChipClickableArea = styled(Chip)`
    .a-chip__close {
        width: 1.4rem;
        height: 1.4rem;
        right: 0.3rem;

        &::before,
        &::after {
            top: 0.25rem;
            right: 0.65rem;
        }
    }
`;

styled(StyledChipClickableArea)`
    margin-top: 0.5rem;
`;

export const FilterCategories = styled.div`
    display: grid;
    font-weight: bold;
`;

export const ContentWrapper = styled.div`
    flex-wrap: wrap;
    margin: 2rem;
    padding-top: 1.5rem;
`;

export const FiltersContent = styled.div`
    padding-bottom: 2rem;
    display: grid;
    grid-template-columns: 1fr 4fr;
    
    @media only screen and (max-width: 768px) {
        grid-template-columns: 2fr 3fr;
    }
`;

export const CloseButtonWrapper = styled.div`
    grid-row: 2;
    grid-column: 1/-1;
    text-align: center;
`;

export const MobileCommandBar = styled.div`
    display: flex;
    align-items: center;
`;

export const FilterSortBar = styled.div`
    display: flex;
    align-items: center;
    width:100%

`;

export const FilterSortContainerBox = styled.div`
    display: flex;
    flex-direction: row;
`;

export const AddBar = styled.div`
    display:flex;
    align-items: flex-end;
`;
